export const SMALL_ICON_SIZE = '16px';
